﻿$.fn.dxCtrlChartHistoEnvoiVueClick = function custom_dxCtrlChartHistoEnvoiVueClick(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcharthistoenvoivueclick dx-ctrl");
        this.createInstance(new cdxCtrlChartHistoEnvoiVueClick(this, option));
    }
    return this;
}

window.cdxCtrlChartHistoEnvoiVueClick = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "datacharthistovue"
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == "undefined") option.bddCtrl.utiCourantParaJson[option.context_grid] = {}
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].filter_histoenvoivueclick == "undefined") option.bddCtrl.utiCourantParaJson[option.context_grid].filter_histoenvoivueclick = {}

    function mConstruit() {
        container.empty()
        container.css({ "height": "100%", "width": "100%" })
        Me.mUpdate()
    }

    var dxChart = null
    var dxZoom = null
    var oldLst = null
    function mRempli(lst) {
        var type = "email/SMS"
        if (option.idTableCom == option.bddCtrl.table.mGetItemFromNom("com_email_envoi").id_table) { type = "email" }
        else if (option.idTableCom == option.bddCtrl.table.mGetItemFromNom("com_sms_envoi").id_table) { type = "SMS" }

        if (lst.length == 0) {
            container.empty()
            dxChart = null
            var lib = ""
            if (option.envoi) lib = "envoi"
            if (option.vue) lib += ((lib.length > 0) ? "/" : "") + "vue"
            if (option.click) lib += ((lib.length > 0) ? "/" : "") + "click"
            $("<div style='width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-family:barlow condensed;opacity:0.5;'>(aucun " + lib + ")</div>").appendTo(container)
        } else {
            if (dxChart == null) {
                container.empty()

                var series = []
                var minDate = null
                var maxDate = null
                if (option.envoi) {
                    series.push({
                        name: "envoi",
                        axis: "envoi",
                        argumentField: 'dat',
                        valueField: 'nb_envoi',
                        type: 'area',
                        color: "green",
                        point: { visible: true }
                    })
                    var newMax = new Date(Math.max(...lst.filter(item => item.nb_envoi > 0).map(item => new Date(item.dat))));
                    if (maxDate == null || maxDate < newMax) maxDate = newMax
                    var newMin = new Date(Math.min(...lst.filter(item => item.nb_envoi > 0).map(item => new Date(item.dat))));
                    if (minDate == null || minDate > newMin) minDate = newMin
                }
                if (option.vue) {
                    series.push({
                        name: "vue",
                        axis: 'vue',
                        argumentField: 'dat',
                        valueField: 'nb_vue',
                        type: 'line',
                        color: "DodgerBlue"
                    })
                    var newMax = new Date(Math.max(...lst.filter(item => item.nb_vue > 0).map(item => new Date(item.dat))));
                    if (maxDate == null || maxDate < newMax) maxDate = newMax
                    var newMin = new Date(Math.min(...lst.filter(item => item.nb_vue > 0).map(item => new Date(item.dat))));
                    if (minDate == null || minDate > newMin) minDate = newMin
                }
                if (option.click) {
                    series.push({
                        name: "click",
                        axis: 'click',
                        argumentField: 'dat',
                        valueField: 'nb_click',
                        type: 'bar',
                        color: 'HotPink',
                        label: {
                            visible: true,
                            position: 'outside',
                            backgroundColor: "rgba(255, 105, 180,0.3)",
                            font: { family: "barlow condensed", size: 10 },
                            customizeText: function (e) {
                                if (e.point.data.nb_click > 0) {
                                    var result = e.point.data.nb_click
                                    return result
                                }
                            }
                        }
                    })
                    var newMax = new Date(Math.max(...lst.filter(item => item.nb_click > 0).map(item => new Date(item.dat))));
                    if (maxDate == null || maxDate < newMax) maxDate = newMax
                    var newMin = new Date(Math.min(...lst.filter(item => item.nb_click > 0).map(item => new Date(item.dat))));
                    if (minDate == null || minDate > newMin) minDate = newMin
                }

                if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].filter_histoenvoivueclick.nb_hours == "undefined") {
                    option.bddCtrl.utiCourantParaJson[option.context_grid].filter_histoenvoivueclick.nb_hours = 24
                }

                var oneDayAgo = new Date(maxDate.getTime() - option.bddCtrl.utiCourantParaJson[option.context_grid].filter_histoenvoivueclick.nb_hours * 60 * 60 * 1000); // 24h avant
                if (minDate != null && (oneDayAgo < minDate || typeof option.idCom != "undefined")) oneDayAgo = minDate
                dxChart = $("<div/>").appendTo(container).dxChart({
                    palette: "Soft",
                    dataSource: lst,
                    series: series,
                    //height: "calc(100% - 120px)",
                    height: "100%",
                    argumentAxis: {
                        argumentType: "datetime",
                        visualRange: [oneDayAgo, maxDate], // 👈 Zoom initial : dernière journée
                        minVisualRangeLength: { hours: 1 },
                        label: {
                            customizeText: function (arg) {
                                const d = new Date(arg.value);
                                return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}<br/>${d.getHours().toString().padStart(2, '0')}h${d.getMinutes().toString().padStart(2, '0')}`;
                            },
                            customizeHint: function (arg) {
                                const d = new Date(arg.value);
                                return d.toLocaleString("fr-FR", {
                                    weekday: "long",
                                    day: "2-digit",
                                    month: "long",
                                    hour: "2-digit",
                                    minute: "2-digit"
                                });
                            },
                            rotationAngle: 45
                        }

                    },
                    onZoomEnd: function (e) {
                        if (e.range && e.range.startValue && e.range.endValue) {
                            const start = new Date(e.range.startValue);
                            const end = new Date(e.range.endValue);
                            const hours = (end - start) / (1000 * 60 * 60); // différence en heures
                            option.bddCtrl.utiCourantParaJson[option.context_grid].filter_histoenvoivueclick.nb_hours = hours
                            option.bddCtrl.mSaveParaJsonUtilisateur();
                        }
                    },
                    onPointClick: function (e) {
                        var minDatPoint = null
                        var maxDatPoint = null
                        var title = ""
                        switch (e.target.series.name) {
                            case "envoi":
                                minDatPoint = new Date(Math.min(...e.target.aggregationInfo.data.filter(item => item.nb_envoi > 0).map(item => new Date(item.dat))));
                                maxDatPoint = new Date(Math.max(...e.target.aggregationInfo.data.filter(item => item.nb_envoi > 0).map(item => new Date(item.dat))));
                                maxDatPoint = (new Date(maxDatPoint)).addMinutes(1)
                                title = "Liste des envois " + type + " entre " + minDatPoint.toDDMMAA() + " " + minDatPoint.toHHMM() + " et " + maxDatPoint.toDDMMAA() + " " + maxDatPoint.toHHMM()
                                break;
                            case "vue":
                                minDatPoint = new Date(Math.min(...e.target.aggregationInfo.data.filter(item => item.nb_vue > 0).map(item => new Date(item.dat))));
                                maxDatPoint = new Date(Math.max(...e.target.aggregationInfo.data.filter(item => item.nb_vue > 0).map(item => new Date(item.dat))));
                                maxDatPoint = (new Date(maxDatPoint)).addMinutes(1)
                                title = "Liste des vues " + type + " entre " + minDatPoint.toDDMMAA() + " " + minDatPoint.toHHMM() + " et " + maxDatPoint.toDDMMAA() + " " + maxDatPoint.toHHMM()
                                break;
                            case "click":
                                minDatPoint = new Date(Math.min(...e.target.aggregationInfo.data.filter(item => item.nb_click > 0).map(item => new Date(item.dat))));
                                maxDatPoint = new Date(Math.max(...e.target.aggregationInfo.data.filter(item => item.nb_click > 0).map(item => new Date(item.dat))));
                                maxDatPoint = (new Date(maxDatPoint)).addMinutes(1)
                                title = "Liste des clicks " + type + " entre " + minDatPoint.toDDMMAA() + " " + minDatPoint.toHHMM() + " et " + maxDatPoint.toDDMMAA() + " " + maxDatPoint.toHHMM()
                                break;
                        }
                        option.bddCtrl.mAjaxCall({
                            command: "gethistoenvoivueclicklstidtableid",
                            id_table_com: option.idTableCom,
                            id_com: option.idCom,
                            min_date: minDatPoint,
                            max_date: maxDatPoint,
                            type: e.target.series.name
                        }, function (data) {
                            if (typeof data.lstidtableid == 'undefined') data.lstidtableid = []
                            page.mAddPopupLst(title, function (contentElement) {
                                $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                    bddCtrl: option.bddCtrl,
                                    lstIdTableIdInclu: data.lstidtableid
                                })
                            })
                        })
                    },
                    commonSeriesSettings: {
                        point: {
                            size: 7,
                        },
                        aggregation: {
                            enabled: true,
                            method: "sum"
                        }
                    },
                    valueAxis: [{
                        name: 'envoi',
                        visible: option.envoi,
                        grid: { visible: option.envoi },
                        label: { visible: option.envoi },
                        minorTick: { visible: option.envoi },
                        tick: { visible: option.envoi },
                        allowDecimals: false,
                        title: ((option.envoi) ? "Nbre d'envoi" : "")
                    }, {
                        name: 'vue',
                        visible: option.vue,
                        grid: { visible: option.vue },
                        label: { visible: option.vue },
                        minorTick: { visible: option.vue },
                        tick: { visible: option.vue },
                        position: 'right',
                        allowDecimals: false,
                        title: ((option.vue) ? "Nbre vues" : "")
                    }, {
                        name: 'click',
                        visible: option.click && !option.vue,
                        grid: { visible: option.click && !option.vue },
                        label: { visible: option.click && !option.vue },
                        minorTick: { visible: option.click && !option.vue },
                        tick: { visible: option.click && !option.vue },
                        position: 'right',
                        allowDecimals: false,
                        title: ((option.click && !option.vue) ? "Nbre clicks" : "")
                    }],
                    scrollBar: {
                        visible: true,
                    },
                    zoomAndPan: {
                        argumentAxis: 'both',
                    },
                    tooltip: {
                        enabled: true,
                        container: "body",
                        zIndex: 99999999999,
                        location: 'edge',
                        customizeTooltip(arg) {
                            var type = ""
                            switch (arg.seriesName) {
                                case "envoi": type = "envoi"; break;
                                case "vue": type = "vue"; break;
                                case "click": type = "click"; break;
                            }
                            return {
                                text: arg.argument.toDDMMAA() + "<br/>" + arg.value + " " + type + ((arg.value > 1) ? "s" : ""),
                            };
                        },
                    },
                    legend: {
                        visible: false,
                    },
                }).dxChart("instance");

                if (option.grid) { //dashboard
                    dxChart.element().on('*', function (event) {
                        console.log(`Événement déclenché: ${event.type}`);
                        console.log('Détails de l\'événement:', event);
                    });
                    //dxChart.element().on("mouseenter", function (e) {
                    //    option.grid.enableMove(false);
                    //    option.grid.enableResize(false);
                    //})
                    dxChart.element().on("mousedown", function (e) {
                        console.log("mousedown")
                        try {
                            option.grid.enableMove(false);
                            option.grid.enableResize(false);
                        } catch (e) { }
                    })
                    dxChart.element().on("mouseup", function (e) {
                        console.log("mouseup")
                        try {
                            option.grid.enableMove(true);
                            option.grid.enableResize(true);
                        } catch (e) { }
                    })
                    dxChart.element().on("mouseleave", function (e) {
                        console.log("mouseleave")
                        try {
                            option.grid.enableMove(true);
                            option.grid.enableResize(true);
                        } catch (e) { }
                    })
                }
                oldLst = lst

            } else {
                if (JSON.stringify(oldLst) != JSON.stringify(lst)) {
                    dxChart.option("dataSource", lst)
                    //dxZoom.option("dataSource", ds)
                    oldLst = lst
                }
            }
        }
    }

    var oldLst = null
    this.mUpdate = function () {
        option.bddCtrl.mAjaxCall({ command: "gethistoenvoivueclick", id_table_com: option.idTableCom, id_com: option.idCom }, function (data) {
            if (typeof data.lstenvoivueclick == 'undefined') data.lstenvoivueclick = []
            if (oldLst == null || JSON.stringify(oldLst) != JSON.stringify(data.lstenvoivueclick)) {
                oldLst = data.lstenvoivueclick
                mRempli(data.lstenvoivueclick)
            }

        })
    }

    this.element = function () { return container }
    this.focus = function () { }

    mConstruit();
}